import { defineComponent, ref, computed } from "vue";
import { _ as _sfc_main$1 } from "./components/VaInputLabel.vue_vue_type_script_setup_true_lang.js";
import { V as VaIcon } from "../va-icon/index.js";
import { u as useInputFieldAriaProps, a as useInputFieldAria } from "./hooks/useInputFieldAria.js";
import { p as pick } from "../../utils/pick.js";
import { W as WithSlotInheritance } from "../../utils/with-slot-inheritance/with-slot-inheritance.js";
import { u as useFormFieldProps } from "../../composables/useFormField.js";
import { u as useSyncProp } from "../../composables/useSyncProp.js";
import { u as useFocusDeep } from "../../composables/useFocusDeep.js";
import { V as VaMessageList } from "../va-message-list/VaMessageList.js";
import { e as extractComponentProps } from "../../utils/component-options/extract-component-options.js";
import { u as useComponentPresetProp } from "../../composables/useComponentPreset.js";
import { b as useValidationProps } from "../../composables/useValidation.js";
import { u as useColors } from "../../composables/useColors.js";
import { u as useBem } from "../../composables/useBem.js";
import { u as useTextColor } from "../../composables/useTextColor.js";
import { u as useNumericProp } from "../../composables/useNumericProp.js";
import { f as filterComponentProps } from "../../utils/component-options/filter-props.js";
const VaInputLabelProps = extractComponentProps(_sfc_main$1);
const _sfc_main = defineComponent({
  name: "VaInputWrapper",
  components: { VaMessageList: WithSlotInheritance(VaMessageList), VaIcon, VaInputLabel: _sfc_main$1 },
  props: {
    ...useComponentPresetProp,
    ...useInputFieldAriaProps,
    ...useFormFieldProps,
    ...useValidationProps,
    ...VaInputLabelProps,
    modelValue: { type: null, default: "" },
    counter: { type: Boolean },
    maxLength: { type: [Number, String], default: void 0 },
    label: { type: String, default: "" },
    placeholder: { type: String, default: "" },
    color: { type: String, default: "primary" },
    background: { type: String },
    success: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    requiredMark: { type: Boolean, default: false },
    innerLabel: { type: Boolean, default: false }
  },
  emits: [
    "click",
    "click-prepend",
    "click-append",
    "click-prepend-inner",
    "click-append-inner",
    "click-field",
    "update:modelValue"
  ],
  setup(props, { emit, slots }) {
    const { getColor } = useColors();
    const [vModel] = useSyncProp("modelValue", props, emit, "");
    const inputRef = ref();
    const isFocused = useFocusDeep();
    const counterValue = computed(
      () => props.counter && typeof vModel.value === "string" ? vModel.value.length : void 0
    );
    const wrapperClass = useBem("va-input-wrapper", () => ({
      ...pick(props, ["success", "error", "disabled", "readonly"]),
      focused: Boolean(isFocused.value),
      labeled: Boolean(props.label || slots.label),
      labeledInner: Boolean(props.label || slots.label) && props.innerLabel
    }));
    const colorComputed = computed(() => getColor(props.color));
    const backgroundComputed = computed(() => props.background ? getColor(props.background) : "#ffffff00");
    const messagesComputed = computed(() => props.error ? props.errorMessages : props.messages);
    const { textColorComputed } = useTextColor(backgroundComputed);
    const maxLengthComputed = useNumericProp("maxLength");
    const messagesColor = computed(() => {
      if (props.error) {
        return "danger";
      }
      if (props.success) {
        return "success";
      }
      return "";
    });
    const errorLimit = computed(() => props.error ? Number(props.errorCount) : 99);
    const isCounterVisible = computed(() => counterValue.value !== void 0);
    const counterComputed = computed(
      () => maxLengthComputed.value !== void 0 ? `${counterValue.value}/${maxLengthComputed.value}` : counterValue.value
    );
    const {
      labelId,
      characterCountId,
      ariaAttributes
    } = useInputFieldAria(props);
    const vaInputLabelProps = filterComponentProps(VaInputLabelProps);
    const focus = () => {
      isFocused.value = true;
    };
    const blur = () => {
      isFocused.value = false;
    };
    return {
      inputRef,
      focus,
      blur,
      labelId,
      characterCountId,
      ariaAttributes,
      vModel,
      counterValue,
      vaInputLabelProps,
      wrapperClass,
      textColorComputed,
      isCounterVisible,
      counterComputed,
      colorComputed,
      backgroundComputed,
      messagesColor,
      messagesComputed,
      errorLimit
    };
  }
});
export {
  _sfc_main as _
};

import '../../../VaInputWrapper.css';
//# sourceMappingURL=VaInputWrapper.vue_vue_type_script_lang.js.map
